// API配置文件
import toastManager from '../utils/toastManager';

export const API_CONFIG = {
  // 注意：微信分享卡片功能需要已备案的域名
  // 当前域名 form.fangxiaojia.vip 无法备案，建议更换为可备案域名
  // 例如：form.yourdomain.com (yourdomain.com 需要已备案)
  BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api',
  ENV_NAME: process.env.NODE_ENV || 'production',
  
  // 移动端网络优化配置
  MOBILE_OPTIMIZATION: {
    // 移动端请求超时时间（毫秒）
    TIMEOUT: 10000,
    // 重试次数
    RETRY_COUNT: 3,
    // 重试间隔（毫秒）
    RETRY_DELAY: 1000,
    // 是否启用缓存
    ENABLE_CACHE: true,
    // 缓存时间（毫秒）
    CACHE_DURATION: 300000 // 5分钟
  }
};

// 请求状态码
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

// 错误消息
export const ERROR_MESSAGES = {
  NETWORK_ERROR: '网络连接异常，请检查网络设置',
  TIMEOUT_ERROR: '请求超时，请稍后重试',
  SERVER_ERROR: '服务器错误，请稍后重试',
  UNAUTHORIZED: '登录已过期，请重新登录',
  FORBIDDEN: '没有权限访问该资源',
  NOT_FOUND: '请求的资源不存在',
  VALIDATION_ERROR: '输入数据有误，请检查后重试',
};

// 显示API响应消息
export const showApiMessage = (response, defaultSuccessMessage = '操作成功') => {
  if (response && response.message) {
    // 根据响应状态判断是成功还是错误消息
    if (response.code === 200) {
              // 操作成功，不显示提示
    } else {
      toastManager.error(response.message);
    }
  } else if (response && response.code === 200) {
    // 如果没有message但有code字段，显示默认成功消息
            // 操作成功，不显示提示
  }
};

// 显示API错误消息
export const showApiError = (error, defaultErrorMessage = '操作失败') => {
  let message = defaultErrorMessage;
  
  if (error && error.message) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }
  
  toastManager.error(message);
}; 